import addressDetails from './addressDetails';
import details from './details';
import obfuscation from './obfuscation';
import historyVisibilityBasedOnPersonalData from './historyVisibilityBasedOnPersonalData';
import nameAndLastnameChange from './nameAndLastnameChange';
import onFirstCoownerLastNameChange from './onFirstCoownerLastNameChange';
import onFirstCoownerNameChange from './onFirstCoownerNameChange';

export const firstCoowner = {
  ...addressDetails,
  ...details,
  ...obfuscation,
  ...historyVisibilityBasedOnPersonalData,
  ...nameAndLastnameChange,
  ...onFirstCoownerLastNameChange,
  ...onFirstCoownerNameChange,
};
